/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdeleted1Inputs */

const en_eventdeleted1 = /** @type {(inputs: Eventdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event deleted`)
};

const de_eventdeleted1 = /** @type {(inputs: Eventdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event gelöscht`)
};

/**
* | output |
* | --- |
* | "Event deleted" |
*
* @param {Eventdeleted1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdeleted1 = /** @type {((inputs?: Eventdeleted1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdeleted1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdeleted1(inputs)
	return de_eventdeleted1(inputs)
});
export { eventdeleted1 as "eventDeleted" }